import {SuggestionsConfigStructure} from "./suggestions-config-structure.model";

export class SuggestionsConfig {

  worksDefinitions: SuggestionsConfigStructure[] = [];

  descriptorsDefinitions: SuggestionsConfigStructure[] = [];

  publicDatasetDefinitions: SuggestionsConfigStructure[] = [];

  constructor(attr: { worksDefinitions: any[], descriptorsDefinitions: any[], publicDatasetDefinitions: any[] }) {
    if (attr.worksDefinitions) {
      attr.worksDefinitions.forEach(workDefinition => {
        this.worksDefinitions.push(new SuggestionsConfigStructure(workDefinition));
      });
    }
    if (attr.descriptorsDefinitions) {
      attr.descriptorsDefinitions.forEach(descriptorDefinition => {
        this.descriptorsDefinitions.push(new SuggestionsConfigStructure(descriptorDefinition));
      });
    }

    if (attr.publicDatasetDefinitions) {
      attr.publicDatasetDefinitions.forEach(publicDatasetDefinition => {
        this.publicDatasetDefinitions.push(new SuggestionsConfigStructure(publicDatasetDefinition));
      });
    }
  }
}
